import {
  DocumentOrganizationKeys,
  FilterDocument,
  FilterOptionKeys,
} from 'shared/types/filter-document';
import { GroupByMode, SortingMode } from 'shared/types/sorting-mode';
import { Tag } from 'shared/types/tag';

export const defaultFilter = (tag?: Tag): FilterDocument => ({
  [DocumentOrganizationKeys.GroupByMode]: GroupByMode.Priority,
  [DocumentOrganizationKeys.SortingMode]: SortingMode.Custom,
  [DocumentOrganizationKeys.Filters]: {
    [FilterOptionKeys.Tag]: { include: [tag?.id ?? ''] },
  },
});

export const getFilterDocument = (tag?: Tag): FilterDocument => {
  const base = defaultFilter(tag);

  return {
    ...base,
    ...(tag?.filterDocument ?? {}),
    [DocumentOrganizationKeys.Filters]: {
      ...base.filters,
      ...(tag?.filterDocument?.filters ?? {}),
    },
  };
};
